import { createAction } from 'redux-actions'

export const clearLevel = createAction('CLEAR_LEVEL')
export const setLadderLevel = createAction('SET_LADDER_LEVEL')
